import api from './api';
import { Staff } from '../types';

const getAll = () => {
  return api.get('/staff');
};

const getById = (id: number) => {
  return api.get(`/staff/${id}`);
};

const create = (data: Staff) => {
  return api.post('/staff', data);
};

const update = (id: number, data: Staff) => {
  return api.put(`/staff/${id}`, data);
};

const remove = (id: number) => {
  return api.delete(`/staff/${id}`);
};

const StaffService = {
  getAll,
  getById,
  create,
  update,
  remove
};

export default StaffService; 